var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.30005 19H6.37505L16.275 9.1L15.2 8.025L5.30005 17.925V19ZM18.425 8.375L15.925 5.9L17.125 4.7C17.325 4.48333 17.5667 4.375 17.85 4.375C18.1334 4.375 18.375 4.48333 18.575 4.7L19.625 5.725C19.825 5.925 19.925 6.16667 19.925 6.45C19.925 6.73333 19.825 6.975 19.625 7.175L18.425 8.375ZM17.7 9.1L6.80005 20H4.30005V17.5L15.2 6.6L17.7 9.1ZM15.725 8.55L15.2 8.025L16.275 9.1L15.725 8.55Z",
    fill: "#15B79E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.8407f08cbcffa8dfa1a819806762702d.svg";
export { ForwardRef as ReactComponent };